import * as React from "react";
import { EmptyWrapperContainer } from "./empty-wrapper-style";
import { TabContext } from "../../../chrome/views/screen-content-renderer/screen-content-renderer";
import AppIcon from "common/app-icon";

interface Props {
    targetRef?: React.RefObject<HTMLElement>;
    forceDisplay?: boolean;
    className?: string;
}

export default class EmptyWrapper extends React.PureComponent<Props> {
    public render(): React.ReactNode {
        const { targetRef, forceDisplay, className } = this.props;
        return (
            <EmptyWrapperContainer className={className} forceDisplay={forceDisplay === true} ref={targetRef as any}>
                <TabContext.Consumer>
                    {value =>
                        value && (
                            <>
                                <div className={"emptyWrapperIcon"}>{<AppIcon icon={value.icon} />}</div>
                                {this.props.children}
                            </>
                        )
                    }
                </TabContext.Consumer>
            </EmptyWrapperContainer>
        );
    }
}
